export default __webpack_public_path__ + "static/media/DarkAgregarUsuario.db4fb06d.svg";